module.exports = __webpack_public_path__ + "img/1.7.2-1.0e744ef5.jpg";